export default "__VITE_ASSET__Z0wPOk49__";